import { Icon, type IconTone } from './Icon';

/** «Живое и на виду»: кольцо с точкой. Отметка версии, стоящей в реестре. */
export function LiveIcon({ size = 11, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={12} tone={tone}>
      <circle cx="6" cy="6" r="4.4" strokeWidth={1} />
      <circle cx="6" cy="6" r="1.7" fill="currentColor" stroke="none" />
    </Icon>
  );
}
